module.exports = __webpack_public_path__ + "static/raj_2-313b9707fd330fdbbcb99a0195d7bdb8.png";